import Breadcrumb from "components/Common/Breadcrumb"
import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Row,
} from "reactstrap"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import downloadIcon from "../../assets/images/download.png"
import * as Yup from "yup"
import toast from "react-hot-toast"
import deleteIcon from "../../assets/images/icons/delete-red1.svg"
import { useParams } from "react-router-dom"
import {
  useCreateTdsMutation,
  useDeleteTdsFilesMutation,
  useLazyGetTdsFilesQuery,
} from "store/api/reports/reports"
import Spinners from "components/Common/Spinner"
import PdfUpload from "./pdfUpload"
import FullPageLoader from "components/fullPageLoader"
import { useSelector } from "react-redux"

const CreateTds = ({ type }) => {
  const { year, period } = useParams()
  const [files, setFiles] = useState([])
  const [trigger, { isLoading }] = useLazyGetTdsFilesQuery()
  const [mutate, { isLoading: isUploading }] = useCreateTdsMutation()
  const [deleteTds] = useDeleteTdsFilesMutation()
  const [docs, setDocs] = useState([])
  const { currentUserMenuType } = useSelector((state) => state.common)

  document.title = `Create ${type === "tds" ? "TDS" : "Account Statment"} | Prachay`

  const getTdsFiles = async () => {
    try {
      const { data, success } = await trigger({
        year,
        period,
        type,
        usertype: currentUserMenuType.toLowerCase(),
      }).unwrap()
      if (success) {
        setFiles(data?.files)
      }
    } catch (error) {}
  }

  const onUploadSuccess = (files) => {
    const newFiles = files.map((item) => ({
      file_name: item.file_name,
      actualFileName: item.file.name,
    }))
    setDocs(newFiles)
  }

  useEffect(() => {
    getTdsFiles()
    validation.setFieldValue("docs", [])
  }, [type, currentUserMenuType])

  const submitData = async (values) => {
    const params = {
      ...values,
      year,
      type,
      period,
      usertype: currentUserMenuType.toLowerCase(),
    }

    try {
      const { success, message } = await mutate(params).unwrap()
      if (success) {
        toast.success(message, { id: "successMessage" })
        location.reload()
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (docs.length > 0) {
      validation.setFieldValue("docs", docs)
    }
  }, [docs])

  const validation = useFormik({
    initialValues: { docs: [] },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    onSubmit: (values) => {
      submitData(values)
    },
  })

  const handleDeleteFile = async (item) => {
    const { filename } = item
    const params = {
      filename,
      year,
      type,
      period,
      usertype: currentUserMenuType.toLowerCase(),
    }
    try {
      const { success, message } = await deleteTds(params).unwrap()

      if (success) {
        toast.success(message, { id: "deleteSuccess" })
        getTdsFiles()
      }
    } catch (error) {}
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title={`Upload ${type === "tds" ? "TDS" : "Account Statment"} for (${year}/${period})`}
        />
        {isLoading ? (
          <FullPageLoader />
        ) : (
          <>
            {files.length > 0 && (
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <div className="playlist-wrapper-section">
                        {files.map((item, index) => (
                          <div
                            key={`document_${index}`}
                            className="playlist-card-box position-relative"
                          >
                            <div className="align-self-center text-center">
                              <img src={pdfIcon} alt="Download PDF" />
                            </div>
                            <p
                              style={{
                                marginTop: "15px",
                              }}
                            >
                              {item?.pdf_url
                                .split("/")
                                .pop()
                                .replace(".pdf", "")}
                            </p>
                            <div
                              style={{
                                textAlign: "center",
                                marginTop: "10px",
                                marginBottom: "14px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                color: "#09518C",
                              }}
                            >
                              <a
                                href={item?.pdf_url}
                                className="d-flex flex-column play-icon"
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#09518C", fontSize: "16px" }}
                              >
                                Download
                              </a>
                              <img height={"20px"} src={downloadIcon} />
                            </div>
                            <div
                              style={{ cursor: "pointer" }}
                              className="upload-delete-icon position-absolute end-0 top-0 p-2"
                              onClick={(e) => {
                                e.stopPropagation()
                                handleDeleteFile(item)
                              }}
                            >
                              <img src={deleteIcon} alt="Delete" />
                            </div>
                          </div>
                        ))}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
            <Form onSubmit={validation.handleSubmit}>
              <Card>
                <CardBody className="pt-4">
                  <CardTitle className="mb-4">File Upload</CardTitle>

                  <PdfUpload onUploadSuccess={onUploadSuccess} />

                  {validation.errors.docs && (
                    <FormFeedback type="invalid">
                      {validation.errors.docs}
                    </FormFeedback>
                  )}

                  {docs.length > 0 && (
                    <Row className="justify-content-end mt-4">
                      <Col sm={12}>
                        <div className="d-flex justify-content-end align-items-center gap-3">
                          <button
                            type="submit"
                            className="btn btn-primary w-md"
                          >
                            {isUploading ? <Spinners /> : "Submit"}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Form>
          </>
        )}
      </Container>
    </div>
  )
}

export default CreateTds
